'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _palette = require('./palette');

var _palette2 = _interopRequireDefault(_palette);

var _colors = require('./colors');

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Fills are used in Avatars and Badges.
 */
var fills = {};

fills.solid = {
  neutral: {
    color: 'white',
    backgroundColor: _palette2.default.neutral.base
  },
  blue: {
    color: 'white',
    backgroundColor: _palette2.default.blue.base
  },
  red: {
    color: 'white',
    backgroundColor: _palette2.default.red.base
  },
  orange: {
    color: 'white',
    backgroundColor: _palette2.default.orange.base
  },
  yellow: {
    color: _palette2.default.yellow.darkest,
    backgroundColor: _palette2.default.yellow.base
  },
  green: {
    color: 'white',
    backgroundColor: _palette2.default.green.base
  },
  teal: {
    color: 'white',
    backgroundColor: _palette2.default.teal.base
  },
  purple: {
    color: 'white',
    backgroundColor: _palette2.default.purple.base
  }
};

fills.subtle = {
  neutral: {
    color: _colors2.default.text.default,
    backgroundColor: _palette2.default.neutral.light
  },
  blue: {
    color: _palette2.default.blue.dark,
    backgroundColor: _palette2.default.blue.light
  },
  red: {
    color: _palette2.default.red.dark,
    backgroundColor: _palette2.default.red.light
  },
  orange: {
    color: _palette2.default.orange.dark,
    backgroundColor: _palette2.default.orange.light
  },
  yellow: {
    color: _palette2.default.yellow.dark,
    backgroundColor: _palette2.default.yellow.light
  },
  green: {
    color: _palette2.default.green.dark,
    backgroundColor: _palette2.default.green.light
  },
  teal: {
    color: _palette2.default.teal.dark,
    backgroundColor: _palette2.default.teal.light
  },
  purple: {
    color: _palette2.default.purple.dark,
    backgroundColor: _palette2.default.purple.light
  }
};

fills.options = Object.keys(fills.solid);

exports.default = fills;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy90aGVtZS9zcmMvZGVmYXVsdC10aGVtZS9mb3VuZGF0aW9uYWwtc3R5bGVzL2ZpbGxzLmpzIl0sIm5hbWVzIjpbImZpbGxzIiwic29saWQiLCJuZXV0cmFsIiwiY29sb3IiLCJiYWNrZ3JvdW5kQ29sb3IiLCJwYWxldHRlIiwiYmFzZSIsImJsdWUiLCJyZWQiLCJvcmFuZ2UiLCJ5ZWxsb3ciLCJkYXJrZXN0IiwiZ3JlZW4iLCJ0ZWFsIiwicHVycGxlIiwic3VidGxlIiwiY29sb3JzIiwidGV4dCIsImRlZmF1bHQiLCJsaWdodCIsImRhcmsiLCJvcHRpb25zIiwiT2JqZWN0Iiwia2V5cyJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUE7Ozs7QUFDQTs7Ozs7O0FBRUE7OztBQUdBLElBQU1BLFFBQVEsRUFBZDs7QUFFQUEsTUFBTUMsS0FBTixHQUFjO0FBQ1pDLFdBQVM7QUFDUEMsV0FBTyxPQURBO0FBRVBDLHFCQUFpQkMsa0JBQVFILE9BQVIsQ0FBZ0JJO0FBRjFCLEdBREc7QUFLWkMsUUFBTTtBQUNKSixXQUFPLE9BREg7QUFFSkMscUJBQWlCQyxrQkFBUUUsSUFBUixDQUFhRDtBQUYxQixHQUxNO0FBU1pFLE9BQUs7QUFDSEwsV0FBTyxPQURKO0FBRUhDLHFCQUFpQkMsa0JBQVFHLEdBQVIsQ0FBWUY7QUFGMUIsR0FUTztBQWFaRyxVQUFRO0FBQ05OLFdBQU8sT0FERDtBQUVOQyxxQkFBaUJDLGtCQUFRSSxNQUFSLENBQWVIO0FBRjFCLEdBYkk7QUFpQlpJLFVBQVE7QUFDTlAsV0FBT0Usa0JBQVFLLE1BQVIsQ0FBZUMsT0FEaEI7QUFFTlAscUJBQWlCQyxrQkFBUUssTUFBUixDQUFlSjtBQUYxQixHQWpCSTtBQXFCWk0sU0FBTztBQUNMVCxXQUFPLE9BREY7QUFFTEMscUJBQWlCQyxrQkFBUU8sS0FBUixDQUFjTjtBQUYxQixHQXJCSztBQXlCWk8sUUFBTTtBQUNKVixXQUFPLE9BREg7QUFFSkMscUJBQWlCQyxrQkFBUVEsSUFBUixDQUFhUDtBQUYxQixHQXpCTTtBQTZCWlEsVUFBUTtBQUNOWCxXQUFPLE9BREQ7QUFFTkMscUJBQWlCQyxrQkFBUVMsTUFBUixDQUFlUjtBQUYxQjtBQTdCSSxDQUFkOztBQW1DQU4sTUFBTWUsTUFBTixHQUFlO0FBQ2JiLFdBQVM7QUFDUEMsV0FBT2EsaUJBQU9DLElBQVAsQ0FBWUMsT0FEWjtBQUVQZCxxQkFBaUJDLGtCQUFRSCxPQUFSLENBQWdCaUI7QUFGMUIsR0FESTtBQUtiWixRQUFNO0FBQ0pKLFdBQU9FLGtCQUFRRSxJQUFSLENBQWFhLElBRGhCO0FBRUpoQixxQkFBaUJDLGtCQUFRRSxJQUFSLENBQWFZO0FBRjFCLEdBTE87QUFTYlgsT0FBSztBQUNITCxXQUFPRSxrQkFBUUcsR0FBUixDQUFZWSxJQURoQjtBQUVIaEIscUJBQWlCQyxrQkFBUUcsR0FBUixDQUFZVztBQUYxQixHQVRRO0FBYWJWLFVBQVE7QUFDTk4sV0FBT0Usa0JBQVFJLE1BQVIsQ0FBZVcsSUFEaEI7QUFFTmhCLHFCQUFpQkMsa0JBQVFJLE1BQVIsQ0FBZVU7QUFGMUIsR0FiSztBQWlCYlQsVUFBUTtBQUNOUCxXQUFPRSxrQkFBUUssTUFBUixDQUFlVSxJQURoQjtBQUVOaEIscUJBQWlCQyxrQkFBUUssTUFBUixDQUFlUztBQUYxQixHQWpCSztBQXFCYlAsU0FBTztBQUNMVCxXQUFPRSxrQkFBUU8sS0FBUixDQUFjUSxJQURoQjtBQUVMaEIscUJBQWlCQyxrQkFBUU8sS0FBUixDQUFjTztBQUYxQixHQXJCTTtBQXlCYk4sUUFBTTtBQUNKVixXQUFPRSxrQkFBUVEsSUFBUixDQUFhTyxJQURoQjtBQUVKaEIscUJBQWlCQyxrQkFBUVEsSUFBUixDQUFhTTtBQUYxQixHQXpCTztBQTZCYkwsVUFBUTtBQUNOWCxXQUFPRSxrQkFBUVMsTUFBUixDQUFlTSxJQURoQjtBQUVOaEIscUJBQWlCQyxrQkFBUVMsTUFBUixDQUFlSztBQUYxQjtBQTdCSyxDQUFmOztBQW1DQW5CLE1BQU1xQixPQUFOLEdBQWdCQyxPQUFPQyxJQUFQLENBQVl2QixNQUFNQyxLQUFsQixDQUFoQjs7a0JBRWVELEsiLCJmaWxlIjoiZmlsbHMuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgcGFsZXR0ZSBmcm9tICcuL3BhbGV0dGUnXG5pbXBvcnQgY29sb3JzIGZyb20gJy4vY29sb3JzJ1xuXG4vKipcbiAqIEZpbGxzIGFyZSB1c2VkIGluIEF2YXRhcnMgYW5kIEJhZGdlcy5cbiAqL1xuY29uc3QgZmlsbHMgPSB7fVxuXG5maWxscy5zb2xpZCA9IHtcbiAgbmV1dHJhbDoge1xuICAgIGNvbG9yOiAnd2hpdGUnLFxuICAgIGJhY2tncm91bmRDb2xvcjogcGFsZXR0ZS5uZXV0cmFsLmJhc2VcbiAgfSxcbiAgYmx1ZToge1xuICAgIGNvbG9yOiAnd2hpdGUnLFxuICAgIGJhY2tncm91bmRDb2xvcjogcGFsZXR0ZS5ibHVlLmJhc2VcbiAgfSxcbiAgcmVkOiB7XG4gICAgY29sb3I6ICd3aGl0ZScsXG4gICAgYmFja2dyb3VuZENvbG9yOiBwYWxldHRlLnJlZC5iYXNlXG4gIH0sXG4gIG9yYW5nZToge1xuICAgIGNvbG9yOiAnd2hpdGUnLFxuICAgIGJhY2tncm91bmRDb2xvcjogcGFsZXR0ZS5vcmFuZ2UuYmFzZVxuICB9LFxuICB5ZWxsb3c6IHtcbiAgICBjb2xvcjogcGFsZXR0ZS55ZWxsb3cuZGFya2VzdCxcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHBhbGV0dGUueWVsbG93LmJhc2VcbiAgfSxcbiAgZ3JlZW46IHtcbiAgICBjb2xvcjogJ3doaXRlJyxcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHBhbGV0dGUuZ3JlZW4uYmFzZVxuICB9LFxuICB0ZWFsOiB7XG4gICAgY29sb3I6ICd3aGl0ZScsXG4gICAgYmFja2dyb3VuZENvbG9yOiBwYWxldHRlLnRlYWwuYmFzZVxuICB9LFxuICBwdXJwbGU6IHtcbiAgICBjb2xvcjogJ3doaXRlJyxcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHBhbGV0dGUucHVycGxlLmJhc2VcbiAgfVxufVxuXG5maWxscy5zdWJ0bGUgPSB7XG4gIG5ldXRyYWw6IHtcbiAgICBjb2xvcjogY29sb3JzLnRleHQuZGVmYXVsdCxcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHBhbGV0dGUubmV1dHJhbC5saWdodFxuICB9LFxuICBibHVlOiB7XG4gICAgY29sb3I6IHBhbGV0dGUuYmx1ZS5kYXJrLFxuICAgIGJhY2tncm91bmRDb2xvcjogcGFsZXR0ZS5ibHVlLmxpZ2h0XG4gIH0sXG4gIHJlZDoge1xuICAgIGNvbG9yOiBwYWxldHRlLnJlZC5kYXJrLFxuICAgIGJhY2tncm91bmRDb2xvcjogcGFsZXR0ZS5yZWQubGlnaHRcbiAgfSxcbiAgb3JhbmdlOiB7XG4gICAgY29sb3I6IHBhbGV0dGUub3JhbmdlLmRhcmssXG4gICAgYmFja2dyb3VuZENvbG9yOiBwYWxldHRlLm9yYW5nZS5saWdodFxuICB9LFxuICB5ZWxsb3c6IHtcbiAgICBjb2xvcjogcGFsZXR0ZS55ZWxsb3cuZGFyayxcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHBhbGV0dGUueWVsbG93LmxpZ2h0XG4gIH0sXG4gIGdyZWVuOiB7XG4gICAgY29sb3I6IHBhbGV0dGUuZ3JlZW4uZGFyayxcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHBhbGV0dGUuZ3JlZW4ubGlnaHRcbiAgfSxcbiAgdGVhbDoge1xuICAgIGNvbG9yOiBwYWxldHRlLnRlYWwuZGFyayxcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHBhbGV0dGUudGVhbC5saWdodFxuICB9LFxuICBwdXJwbGU6IHtcbiAgICBjb2xvcjogcGFsZXR0ZS5wdXJwbGUuZGFyayxcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHBhbGV0dGUucHVycGxlLmxpZ2h0XG4gIH1cbn1cblxuZmlsbHMub3B0aW9ucyA9IE9iamVjdC5rZXlzKGZpbGxzLnNvbGlkKVxuXG5leHBvcnQgZGVmYXVsdCBmaWxsc1xuIl19